module.exports = __webpack_public_path__ + "img/6.05830ee9.png";